import ArchiveUsers from '@/features/filestore/dialogs/ArchiveUsers'

export default {
  methods: {
    modalProps() {
      if (rootStore.isMobile) {
        return {
          width: window.innerWidth,
          height: window.innerHeight,
          shiftY: 0,
          classes: 'fullscreen-modal',
          adaptive: false
        }
      } else {
        return {
          width: 650,
          height: 498
        }
      }
    },
    getUsers(archiveId) {
      this.$modal.show(
        ArchiveUsers,
        {
          archiveId: archiveId
        },
        this.modalProps()
      )
    }
  }
}
